import {
    apiRequest,
    unitkerjaDataTable,
    unitkerjaDelete,
    unitkerjaActivate,
    unitkerjaSubmit
} from "../../../../../services/adapters/master/penialian360Service"

class UnitKerjaRepository {

    fetchDataTable = async (query, cancelToken) => {
        return await apiRequest("get", unitkerjaDataTable, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchSubmit = async (query) => {
        return await apiRequest("post", unitkerjaSubmit, {
            body: query
        }, true)
    }

    fetchDelete = async (query) => {
        return await apiRequest("post", unitkerjaDelete, {
            body: query
        }, true)
    }

    fetchActivate = async (query) => {
        return await apiRequest("post", unitkerjaActivate, {
            body: query
        }, true)
    }

}

export default UnitKerjaRepository